import React from 'react';
import {Box, Stack, styled} from '@mui/material';
import {
  designSystemToken,
  Headline,
  Body,
} from '@lightricks/react-design-system';
import translate from '@/utils/translate';

const Container = styled(Box)(() => ({
  boxSizing: 'border-box',
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: designSystemToken('semantic.bg.secondary'),
  border: `1px solid ${designSystemToken('semantic.bg.neutral-secondary')}`,
  borderRadius: '32px',
  padding: '32px',
}));

const IllustrationContainer = styled(Box)(() => ({
  width: '100%',
  height: '162px',
  backgroundImage: `url('https://storage.googleapis.com/brands-public-assets/content-lab/ai-avatars-empty2.png')`,
  backgroundSize: 'contain',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
}));
interface EmptyAiAvatarContentProps {
  testID?: string;
}

function EmptyAiAvatarContent({
  testID = 'empty-ai-avatar-content',
}: EmptyAiAvatarContentProps) {
  return (
    <Container data-testid={testID}>
      <Stack
        direction="column"
        gap="24px"
        alignItems="center"
        textAlign="center"
        sx={{maxWidth: '720px'}}
      >
        <IllustrationContainer />
        <Body
          size="lg"
          color={designSystemToken('semantic.fg.secondary')}
          sx={{whiteSpace: 'pre-line'}}
        >
          {translate(
            'Generate a script, choose your avatar,\nand get your video instantly.'
          )}
        </Body>
      </Stack>
    </Container>
  );
}

export default EmptyAiAvatarContent;
